// extracted by mini-css-extract-plugin
module.exports = {"personContactInfo":"PersonDetailsInfo_personContactInfo__cFPCa","label":"PersonDetailsInfo_label__AB71m"};